import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import { MisterIcon } from "@rtel/mister-icons";
import { Button } from "reactstrap";
import Modal from "src/components/Common/UI/Modal/Modal";
import CreateLine from "./CreateLine";
import EditLine from "./EditLine";
import DeleteLine from "./DeleteLine";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import { useLinesDataViewLogic } from "./hooks/useLinesDataViewLogic";
import ReportDownload from "src/components/Common/UI/ReportDownload/ReportDownload";


const LinesDataView = () => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent,
    numberOfRowsTitle,
    visibleTotalRecords,
    downloadAnchorRef,
    canDownloadCsv,
    canDownloadExcel
  } = useLinesDataViewLogic();

  const addLineButton: React.FC = () => {
    return (
      <>
      <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέα Γραμμή Data`)}
      </Button>
      <ReportDownload event={actionEvent} canDownloadCsv={canDownloadCsv} canDownloadExcel={canDownloadExcel} />
      </>
    )
  };

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} />
  );

  return (
    <>
      <a ref={downloadAnchorRef} href="#" style={{ display: 'none' }} />
        {loadingDone && (
          <>
            <Table
                columns={columns}
                data={data}
                defaultOrderByKeyFilter={"id"}
                showNumberOfRows={true}
                rowSelection={true}
                setRowSelection={setSelectedRowsOfTable}
                multipleRowSelection={false}
                actionRowId={"id"}
                debugMode={false}
                noDataFoundTitle="No Lines yet"
                isChangeOrderOrVisibilityEnable={false}
                ButtonsAreaLeft={ActionButtons}
                ButtonsAreaRight={addLineButton}
                maxHeight="33rem"
                numberOfRows={visibleTotalRecords}
                numberOfRowsTitle={numberOfRowsTitle}
            />
          </>
        )}

        <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}  
          size="xl"
          >
            {modalEvent.action === "create" && <CreateLine handleCloseModal={closeActionModal}/> }
            {modalEvent.action === "edit" && <EditLine handleCloseModal={closeActionModal} lineId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
            {modalEvent.action === "delete" && <DeleteLine handleCloseModal={closeActionModal} lineId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
        </Modal>

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default LinesDataView;

